import StateControllerBase from "@/store/stateControllerBase";
import { setLoadingState } from "@/store/setLoadingState";

import ProfileController from "@/api/profileController";
const profileController = new ProfileController();

class Actions extends StateControllerBase {
  setDataLoading({ commit }, dataLoading) {
    commit("setDataLoading", dataLoading);
  }

  setTestRole({ commit }, isTestRole) {
    commit("setTestRole", isTestRole);
  }

  @setLoadingState
  async getProfile({ commit }, id) {
    let data = await profileController.getProfile(id);
    commit("setProfile", data);
  }

  async removeProfile({ commit }) {
    commit("setProfile", null);
  }

  @setLoadingState
  async getActiveSession({ commit }, params) {
    let resp = await profileController.getActiveSession(params);
    commit("setActiveSession", resp);
    return resp;
  }

  @setLoadingState
  async closeActiveSession() {
    let data = await profileController.closeActiveSession();
    return data;
  }

  // @setLoadingState // for Socket
  async getProfileWihtoutLoading({ commit }, id) {
    let data = await profileController.getProfile(id);
    commit("setProfile", data);
  }

  // @setLoadingState
  async editProfile(_context, data) {
    const params = {
      iName: data?.iName,
      fName: data?.fName,
      oName: data?.oName
    };
    await profileController.editProfile(data.id, params);
  }

  async generateSystemWallet({ commit }) {
    const resp = await profileController.generateSystemWallet();
    commit("setSystemWallet", resp?.data);
    return resp?.data;
  }

  async confirmEmail(_context, url) {
    return await profileController.confirmEmail(url);
  }

  @setLoadingState
  async patchProfile(_context, { id, params }) {
    await profileController.editProfile(id, params);
  }

  async fakeKYCSuccess(_context) {
    return await profileController.fakeKYCSuccess();
  }

  async get2faMandatory(_context) {
    return await profileController.get2faMandatory();
  }
}
export default (new Actions).asPlainObject();